<app-data-selector [open]="open"
                   [required]="required"
                   [singular]="singular"
                   [localisation]="localisation"
                   [data]="selectablePromotionalTypes | async"
                   [categoryFilter]="promotionalTypeGroupFilter"
                   [columnExtractor]="promotionalTypeColumnExtractor"
                   [zeroSelectedTemplate]="zeroSelected"
                   [oneSelectedTemplate]="oneSelected"
                   [manySelectedTemplate]="manySelected"
                   (submitted)="submit($event)"
                   (cancelled)="cancel()">
</app-data-selector>

<ng-template #zeroSelected let-c='selectedCount'>

  <span i18n="@@communication-centre.advertiser.promotional-type-selector.label.zero-selected">
    Selected: {{c}}
  </span>

</ng-template>

<ng-template #oneSelected let-c='selectedCount'>

  <span i18n="@@communication-centre.advertiser.promotional-type-selector.label.one-selected">
    Selected: {{c}}
  </span>

</ng-template>

<ng-template #manySelected let-c='selectedCount'>

  <span i18n="@@communication-centre.advertiser.promotional-type-selector.label.many-selected">
    Selected: {{c}}
  </span>

</ng-template>
